import { unref } from 'vue';

import { i18n } from '@/i18n';

/**
 * Navigate to a given path
 * @param path - path to navigate to
 * @param options - optional parameters for the navigation
 */
export const navigate = (path, options = {}) => {
  if (typeof path !== 'string' || !path) {
    return;
  }
  let url = path;
  if (options.query !== undefined) {
    const queryString = Object.keys(options.query)
      .map((key) => {
        const value = options.query ? options.query[key] : '';
        return `${key}=${value}`;
      })
      .join('&');
    url += `?${queryString}`;
  }

  if (options.newTab) {
    window.open(url, '_blank')?.focus();
  } else {
    window.location.href = url;
  }
};

/**
 * Navigate to a given Help Center page
 * @param page - HC page to navigate to
 * @param newTab - whether to open in a new tab
 */
export const navigateToHc = async (page, newTab = true) => {
  const helpCenterPages = {
    main: '',
    accountSettings: 'collections/13384025-account-settings',
  };

  const helpCenterLocales = {
    en: 'en',
    es: 'es',
    fr: 'fr',
    de: 'de',
  };

  const helpCenterPage = helpCenterPages[page] ?? page;
  const userLocale = unref(i18n.global.locale) ?? 'en';
  const helpCenterLocale = helpCenterLocales[userLocale] ?? 'en';

  navigate(`https://support.thehotelsnetwork.com/${helpCenterLocale}/${helpCenterPage}`, { newTab });
};
